import { render, staticRenderFns } from "./FormTindakanRanap.vue?vue&type=template&id=39590e98&"
import script from "./FormTindakanRanap.vue?vue&type=script&lang=js&"
export * from "./FormTindakanRanap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports